import axios from "../http";
import { handleGetRequestParams } from '../common/js/util'

class Temporary {
  //根据仓库搜索劳务公司
  getTempLaborListByWarehouse(option) {
    let url = `/oa/api/pc/temp/labor/overview/list?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 获取支出信息列表
  getExpenditureList(option) {
    let url = `/oa/api/pc/temp/salary/page?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  } 
  // 编辑支出信息
  postModExpenditure(data) {
    const url = `/oa/api/pc/temp/salary/update`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 核实支出信息
  postVerifyExpenditure(data) {
    const url = `/oa/api/pc/temp/salary/check`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 是否核实
  getIsVerifyExpenditure(option) {
    let url = `/oa/api/pc/temp/salary/check/detail?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 撤销核实
  postWithdrawalVerification(data) {
    const url = `/oa/api/pc/temp/salary/cancel/check`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //导出
  getExportExcel(option) {
    let url = `/oa/api/download/temp/salary?`;
    url += handleGetRequestParams(option)
    return axios.get(url, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
}

export default Temporary;
